import { Box,  Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useEffect } from 'react'

import WelcomBox from './WelcomBox';
import StatisticsBox from './StatisticsBox';
import GreenHouseBox from './GreenHouseBox';
import FranchizeBox from './FranchizeBox';
import AboutManagerBox from './AboutManagerBox';
import CooperationBox from './CooperationBox';
import { useDispatch, useSelector } from 'react-redux';
import { numbers, slider } from '../../feature/api/Download';
import { useNavigate } from 'react-router-dom';
import BreadFactory from './BreadFactory';
import Bread from './Bread';

import ItSection from './ItSection';
import { newofBranch } from '../../feature/api/branch';
const Home = () => {
  const navigate = useNavigate()
    const theme = useTheme()
    const phone = useMediaQuery(theme.breakpoints.between(280,830))
    const tablet = useMediaQuery(theme.breakpoints.between(500,830))
    const news = useSelector(state => state.branches.news)

    const dispatch = useDispatch()
    const number = useSelector(state => state.download.num)
    const sliders = useSelector(state => state.download.slider)

    function reveal() {
      var reveals = document.querySelectorAll(".reveal");
    
      for (var i = 0; i < reveals.length; i++) {
        var windowHeight = window.innerHeight;
        var elementTop = reveals[i].getBoundingClientRect().top;
        var elementVisible = 100;
    
        if (elementTop < windowHeight - elementVisible) {
          reveals[i].classList.add("active");
        } else {
          reveals[i].classList.remove("active");
        }
      }
    }
    function fade() {
      var reveals = document.querySelectorAll(".fade-bottom");
    
      for (var i = 0; i < reveals.length; i++) {
        var windowHeight = window.innerHeight;
        var elementTop = reveals[i].getBoundingClientRect().top;
        var elementVisible = 100;
    
        if (elementTop < windowHeight - elementVisible) {
          reveals[i].classList.add("active");
        } else {
          reveals[i].classList.remove("active");
        }
      }
    }
    useEffect(() => {
      window.addEventListener('scroll', () => {
        document.body.style.setProperty('--scroll', window.pageYOffset / (document.body.offsetHeight - window.innerHeight));
      }, false);
      window.addEventListener("scroll", reveal);
      window.addEventListener("scroll", fade);
      dispatch(slider())
      dispatch(numbers())
      dispatch(newofBranch())
    }, [])
    
  return (
    <Box display={"flex"} flexDirection={"column"} gap={10} >
      <Box position={"relative"} height={!phone? '750px':"auto"} >

         <WelcomBox phone={phone} tablet={tablet} slider={sliders} />
      </Box>
        <Box  display={"flex"} flexDirection={"column"}   mt={'64px'}    >
            <StatisticsBox phone={phone} />
          <Bread phone={phone}/>
            <GreenHouseBox phone={phone} />
            <BreadFactory phone={phone}/>
            <ItSection  phone={phone}/>

            <FranchizeBox phone={phone} />
          
            
    
            
            <AboutManagerBox phone={phone} />
            
            
            
               <CooperationBox phone={phone} number={number} />
             
            </Box> 

          
           
          
          
         
      </Box>
  )
}

export default Home